import { useToasts } from "../lib/toast.js";

// Стек тостов внизу по центру. Кликом можно закрыть досрочно.
export const Toasts = () => {
  const toasts = useToasts((state) => state.toasts);
  const dismiss = useToasts((state) => state.dismiss);
  if (toasts.length === 0) {
    return null;
  }
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          className={`toast toast--${toast.kind}`}
          onClick={() => dismiss(toast.id)}
        >
          <span className="toast__dot" aria-hidden="true" />
          <span className="toast__text">{toast.text}</span>
        </button>
      ))}
    </div>
  );
};

export default Toasts;
